/**
 * File: image-text-hero.js
 *
 * Import and initialize functions for the hero styling
 */

export default {
	isPressPage: document.querySelector('body.single-post'),
	init() {
		if (this.isPressPage) this.render();
	},
	render() {
		const heroWrapper = document.querySelector('#header-title');
		const hero = heroWrapper.querySelector('.elementor-widget-trx_sc_layouts_title');
		const title = hero.querySelector('.sc_layouts_title h1.sc_layouts_title_caption');

		heroWrapper.style.setProperty('margin-bottom', '-15px', 'important');
		hero.classList.remove('not-press-release');
		title.style.fontSize = "452px";
		title.style.lineHeight = "50px";
		title.style.maxWidth = "1120px";
		title.style.textTransform = "unset";
	},
};
